import feathers from '@feathersjs/client';
import { appContainer } from '../contexts/app';
import { validate, validateEmail, validatePassword } from './hooks';
const { BadRequest } = feathers.errors;

export default app => {
  // Setup the authentication service, which adds
  // app.authenticate method
  app.configure(
    feathers.authentication({
      storage: localStorage,
      storageKey: 'mapplug-token',
      timeout:Number.parseInt(process.env.REACT_APP_SOCKET_TIMEOUT, 10)
    })
  );

  // Unfortunately the socket.io transport does not
  // call the underlying app.service('authentication') service
  // and fire its hooks. So, we have to wrap this function in
  // another method which calls the sessions service and
  // sets state, which we could do in a hook if the service were
  // actually called by the socket transport
  app._authenticate = async credentials => {
    const token = await app.authenticate(credentials);
    appContainer.set('authenticated', true);
    return token;
  };

  const validateSignup = validate({
    first_name: 'First name is required',
    last_name: 'Last name is required',
    account_name: 'Organization name is required',
    address: 'Address is required',
    // geo: [],
    email: validateEmail,
    password: validatePassword
  });

  app.service('auth/signup').hooks({
    before: {
      create: [validateSignup]
    }
  });
  // Lengthen the timeout to allow for signup
  // doing lots of heavy lifting on the backend
  app.service('auth/signup').timeout = 20000;

  const validateForgotPassword = validate({
    email: validateEmail
  });

  app.service('auth/password-forgot').hooks({
    before: {
      create: [validateForgotPassword]
    }
  });

  const validatePasswords = (item, data) => {
    const { confirmPassword, password } = data;
    if (!password || !confirmPassword) {
      throw new BadRequest('Both passwords are required');
    }
    if (confirmPassword !== password) {
      throw new BadRequest('Passwords do not match');
    }
    validatePassword(password);
  };

  const validateResetPassword = validate({
    password: validatePasswords,
    confirmPassword: validatePasswords
  });

  app.service('auth/password-reset').hooks({
    before: {
      create: [validateResetPassword]
    }
  });

  app.service('auth/accept-invite').hooks({
    before: {
      update: [deleteUserId]
    }
  });
};

// Passing a user up to the accept-invite service does
// not run through the normal `fromImmutable` hook which
// removes the _id is creating. Remove it manually so that
// the server does not barf about trying to create a user with
// and _id already set.
const deleteUserId = context => {
  if (context.data.user && context.data.user.toJS) {
    context.data.user = context.data.user.toJS();
    delete context.data.user._id;
    return context;
  } else {
    return context;
  }
};



// WEBPACK FOOTER //
// ./src/feathers/auth.js